<template>
    <div :name="`name${data.qid}`"  class="test_question list">
        <div class="title" 
            :class="{'required':data.mustanswer}"
            :style="{
                fontSize: bandingstyle.appearance.fontStemSize+'px',
                color:bandingstyle.appearance.fontStemColor,
                fontWeight: bandingstyle.appearance.fontStemBold,
                fontStyle: bandingstyle.appearance.fontStemItalic,
                textDecoration: bandingstyle.appearance.fontStemUnderline
            }"
        >
            <span v-if="showTitleNum == 1">{{data.quesIndex + 1}}、</span>
            <HtmlClickImgEnlarge :content="data.questionsName"/>
        </div>
        
        <div class="input_box"> 
            <el-radio-group @change="userAnswerChange" v-if="data.questionsTypeId == 100 || data.questionsTypeId == 102" v-model="data.userAnswer" class="option-box">
                <!-- {{data.showcolnum}} -->
                <template v-for="info in data.optionList" >
                    <el-radio 
                        class="option"
                        :key="info.oid" 
                        :label="info.oid"
                        :style="{
                            fontSize: bandingstyle.appearance.fontOptionSize+'px !important',
                            color:bandingstyle.appearance.fontOptionColor,
                            fontWeight: bandingstyle.appearance.fontOptionBold,
                            fontStyle: bandingstyle.appearance.fontOptionItalic,
                            textDecoration: bandingstyle.appearance.fontOptionUnderline,
                            width: data.showcolnum == 1?'100%':(data.showcolnum == 2?'50%':(data.showcolnum == 3?'30.3%':'25%'))
                        }"
                    >
                        <HtmlClickImgEnlarge :content="info.labelName"/>
                    </el-radio>
                    <div v-if="info.haveInput && data.userAnswer == info.oid"
                        :key="`op${info.oid}`"
                        class="other-input">
                        <el-input
                            size="medium"
                            :placeholder="$t('UserAnswer.PleaseEnter')"
                            v-model="info.inputValue"
                            >
                        </el-input>
                    </div>
                </template>
            </el-radio-group>
            
            <el-checkbox-group @change="userAnswerChange" v-else-if="data.questionsTypeId == 101" v-model="data.userAnswerArr" class="option-box">
                <template v-for="info in data.optionList" >
                    <el-checkbox 
                        class="option" 
                        :key="info.oid" 
                        :label="info.oid"
                        :style="{
                            fontSize: bandingstyle.appearance.fontOptionSize+'px !important',
                            color:bandingstyle.appearance.fontOptionColor,
                            fontWeight: bandingstyle.appearance.fontOptionBold,
                            fontStyle: bandingstyle.appearance.fontOptionItalic,
                            textDecoration: bandingstyle.appearance.fontOptionUnderline,
                            width: data.showcolnum == 1?'100%':(data.showcolnum == 2?'50%':(data.showcolnum == 3?'30.3%':'25%'))
                        }"
                    >
                        <HtmlClickImgEnlarge :content="info.labelName"/>
                    </el-checkbox>
                    <div v-if="info.haveInput && data.userAnswerArr.indexOf(info.oid) != -1"
                        :key="`op${info.oid}`"
                        class="other-input">
                        <el-input
                            size="medium"
                            :placeholder="$t('UserAnswer.PleaseEnter')"
                            v-model="info.inputValue"
                            >
                        </el-input>
                    </div>
                </template>
            </el-checkbox-group>
            <div v-show="data.validate" class="form-item__error">{{data.validateMsg}}</div>
        </div>
    </div>
</template>

<script>
import HtmlClickImgEnlarge from '@/components/myComponents/htmlClickImgEnlarge.vue'
export default {
    components: {
        HtmlClickImgEnlarge
    },
    props: {
        data: {},
        bandingstyle:{},
        showTitleNum:{
            type: Number,
            default: 0
        }
    },
    created() {
        
        // console.log("this.data>>",this.data)
        // console.log(this.data.questionsTypeId)
        // console.log(this.data.userAnswerArr)
        
    },
    methods: {
        userAnswerChange() {
            this.$emit('userAnswerChange', this.data)
        }
    }
}
</script>

<style lang="scss" scoped>
.test_question{
    .title{
        margin-bottom: 30px;
        word-break: break-all;
        display: flex;
    }
    .option-box{
        display: flex;
        flex-wrap: wrap;
        // padding-left: 25px;
        box-sizing: border-box;
        .option{
            margin-top: 10px;
            display: flex;
            
        }
        .other-input{
                width: 100%;
                margin: 10px 0;
            }
            /deep/.el-checkbox__label{
                display: flex;
                align-items: center;
                white-space: normal;
                word-break: break-all;
            }
            /deep/.el-checkbox__input{
                display: inline-block;
                margin-top:3px;
            }
            //.other-input /deep/.el-input--mini .el-input__inner{
            //     height: 22px;
            //     line-height: 22px;
            // }
        /deep/.el-radio{
            margin-right: 0;
        }
        /deep/.el-checkbox{
            margin-right: 0;
        }
    }
}
.required::before{
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}
/deep/.el-checkbox__label,
/deep/.el-radio__label{
    display: flex;
    align-items: center;
    white-space: normal;
    word-break: break-all;
    font-size: inherit;
    text-decoration: inherit;
}
/deep/.el-tiptap-editor__content{
    line-height: 1.3;
    overflow-x: visible
}
</style>
